import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {
  alto,
  darkRed,
  kimberlyLighter,
  wineRed,
} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    paddingHorizontal: 10,
    width: '98%',
  },
  container: {
    borderColor: alto,
    borderWidth: 1,
    width: '91%',
    borderRadius: 4,
    marginLeft: indent * 1,
  },
  accordionHeader: {
    flex: 1,
    backgroundColor: white,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  alertButtonIcon: {
    fontSize: 18,
    fontWeight: '700',
    color: wineRed,
  },
  accordionIcon: {
    marginTop: indent * 0.2,
  },

  accordionBodyContent: {
    backgroundColor: white,
    flexDirection: 'row',
    marginBottom: indent * 0.3,
    paddingVertical: indent * 0.1,
    marginLeft: indent * 0.1,
    marginTop: indent * 0.5,
  },
  textStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textNameLabel: {
    fontSize: 16,
  },
  textEmail: {
    justifyContent: 'flex-end',
    fontSize: 14,
  },
  trashIcon: {
    color: wineRed,
    fontSize: 16,
    ...getFontFamily('bold'),
    marginLeft: 14,
    marginRight: 4,
  },
  removeLabel: {
    color: darkRed,
    fontSize: 14,
    paddingLeft: indent * 0.1,
  },
  buttonBox: {
    justifyContent: 'center',
    borderColor: kimberlyLighter,
    width: '100%',
    borderRadius: indent * 0.4,
    marginBottom: indent * 0.5,
    height: 40,
  },
  textContainer: {
    marginTop: indent * 0.4,
    fontSize: 16,
    marginLeft: 10,
  },
});
